export const API = {
  license:   import.meta.env.VITE_LICENSE_URL   || 'http://localhost:4000',
  auth:      import.meta.env.VITE_AUTH_URL       || 'http://localhost:4001',
  regulator: import.meta.env.VITE_REGULATOR_URL  || 'http://localhost:4002',
  iot:       import.meta.env.VITE_IOT_URL        || 'http://localhost:4003',
  tender:
    import.meta.env.VITE_TENDER_URL ||
    import.meta.env.VITE_TENDER_API_URL ||
    'http://localhost:4004',
  webhook:   import.meta.env.VITE_WEBHOOK_URL    || 'http://localhost:4005',
  golive:    import.meta.env.VITE_GOLIVE_URL     || 'http://localhost:4006',
  scoring:   import.meta.env.VITE_SCORING_URL    || 'http://localhost:4007',
  national:  import.meta.env.VITE_NATIONAL_URL   || 'http://localhost:4008',

  miniEsg: import.meta.env.VITE_MINI_ESG_API || 'http://localhost:4017',
  fundingRadar: import.meta.env.VITE_FUNDING_API_URL || 'http://localhost:4018',
  sovereignReconciliation:
    import.meta.env.VITE_SOVEREIGN_RECONCILIATION_API_URL || 'http://localhost:4012',
  subsidyAllocation:
    import.meta.env.VITE_SUBSIDY_ALLOCATION_API_URL || 'http://localhost:4011',
  antiFraud: import.meta.env.VITE_ANTIFRAUD_API_URL || 'http://localhost:4010',
  satelliteOverlay:
    import.meta.env.VITE_SATELLITE_OVERLAY_API_URL || 'http://localhost:4016',
  judicialTrigger:
    import.meta.env.VITE_JUDICIAL_TRIGGER_API_URL || 'http://localhost:4015',
  beneficialGraph:
    import.meta.env.VITE_BENEFICIAL_GRAPH_API_URL || 'http://localhost:4014',
  subsidyEligibility:
    import.meta.env.VITE_SUBSIDY_ELIGIBILITY_API_URL || 'http://localhost:4013',
};
